<nav class="nav nav-secondary account-navbar">
  <!--Account-->
  <a
    class="nav-item"
    [routerLink]="['/account']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'account.nav.account.screenreader' | translate: { fgbdefault: 'Move to Account page' } }}"
  >
    <label>{{ 'account.nav.profile' | translate }}</label>
  </a>

  <a
    class="nav-item"
    [routerLink]="['/activity']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'account.nav.activity.screenreader' | translate: { fgbdefault: 'Move to activity page' } }}"
  >
    <label>{{ 'account.nav.activity' | translate }}</label>
  </a>
</nav>
